module.exports = __webpack_public_path__ + "media/images/workplace/banners/more_to_do/more_to_do_gender_card-9f5f2f8ea9b93915495dc27ea07f7a73.jpg";